import React, { useState } from "react";
import { ActivityFeed } from "@ofqual/portal-activity-feed";
import { buildDefinitions } from "./buildDefinitions";
import { EntityDialog, DialogType } from "./types";
import { RenderDialog } from "./RenderDialog";
import { Qualification } from "../../../domain/Qualification";

type QualificationActivityFeedProps = {
  qualification: Qualification;
};

export const QualificationActivityFeed: React.FC<QualificationActivityFeedProps> = ({
  qualification,
}) => {
  const [focussedEntity, setFocussedEntity] = useState<EntityDialog | null>(
    null
  );

  const definitions = buildDefinitions((activity) => {
    setFocussedEntity({
      dialogType: DialogType.ActivityAction,
      focussedActivity: activity,
    });
  }, qualification);

  return (
    <>
      <ActivityFeed
        resourceId={qualification.id}
        definitions={definitions}
        actions={[
          {
            label: "Send Message",
            dataTest: "send-message",
            action: () =>
              setFocussedEntity({
                dialogType: DialogType.SendMessage,
              }),
            disabled: false,
          },
        ]}
      />
      <RenderDialog
        focussedEntity={focussedEntity}
        onClose={() => setFocussedEntity(null)}
        qualification={qualification}
      />
    </>
  );
};
